import { Outlet } from 'react-router-dom';
import { SidebarNav } from './SidebarNav';
import { TopBar } from './TopBar';
import { useUIStore } from '@/store/ui';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import styles from './AppShell.module.css';

export function AppShell() {
  const collapsed = useUIStore((s) => s.sidebarCollapsed);
  return (
    <div className={styles.shell}>
      <SidebarNav collapsed={collapsed} />
      <div className={styles.main}>
        <TopBar />
        <main className={styles.content}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
